import Vue from "vue";
import { post, fetch, Del, put } from "../../../../ask/axios";
import bus from '../../../../ask/eventBus';
import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue'
import CommonInvoiceInput from '../../../../components/userCenter/public/CommonInvoiceInput.vue'
export default {
  components: { menberMenu,CommonInvoiceInput},
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: "" 
      },
      titNames: "My invoice,Make invoice",
      titUrls: "/myInfo/myInvoice,",
      showModal:false,//弹框遮罩层
      //传值到我的发票组件中
      ConsigDefaultMsg:{},  
      ConsignorMsg:{},//发件人信息 
      //产品信息取默认值，赋值到发票组件中
      porductDefultMsg:[],  
      //发票编辑信息传值到我的发票组件中
      myInvoiceInfo:{},  
      ordNo:'', //订单号
    };
  },

  async created() {
    //通过地址栏上的发件人ID判断是新增还是编辑  ConsignorID=0是新增；ConsignorID>0是编辑
    //console.log('this.$route.query.ConsignorID222  ' +  this.$route.query.ConsignorID)
    if(this.$route.query.ConsignorID>0){
      this.shipDisabled=true
    }else{
      this.shipDisabled=false
    }

    if(this.$route.query.ConsignorID > 0){
      await this.getConsignorDataAPI(this.$route.query.ConsignorID);
    }

    if(this.$route.query.ConsigneeID==0){
      await this.getReDataAPI();//收件人地址取默认值接口
      await this.getCargoDataAPI(); //产品信息取默认值接口
      this.myInvoiceInfo = null;
    }else{
      await this.getInvoiceInfo(this.$route.query.CusInvoiceID) //获取发票详情接口数据
      this.ConsigDefaultMsg = null;
      this.porductDefultMsg = [];
    }

    let DesCounInfo=null
    this.$refs.clkSubmit.setData(this.ConsigDefaultMsg,this.ConsignorMsg,this.porductDefultMsg,this.myInvoiceInfo,this.ordNo,this.shipDisabled,DesCounInfo);
  },
  mounted() {
  },
  watch: {

  },
  computed: {//计算属性周期函数

  },
  methods: {
    //收件人信息默认值取值，赋值到我的发票上
     //收货地址接口
     async  getReDataAPI(){
      let that = this;
      // that.api.url=that.$api02 + '/api/EbayCustomer/Addressee/List';
      that.api.url=that.$api04 + "/Basics/api/Addressee/List";
      await post(that.api.url, {
        Page: 1,
        Size: 99999
      }).then(function (res) {
          if(res.Results){
            res.Results.forEach(e =>{
              if(e.Address_IsDefault==true){
                that.ConsigDefaultMsg=e
              }
            })
          }
      })
    }, 
     //有发件人ID取发件人信息赋值到我的发票组件上
     async getConsignorDataAPI(ConsignorID){
      let that = this;
      // that.api.url=that.$api02 + '/api/EbayCustomer/Addresser/List';
      that.api.url=that.$api04 + '/Basics/api/Addresser/List';
      await post(that.api.url).then(function (res) {
          if(res.Results){
            res.Results.forEach(e =>{
              if(e.Address_ID==ConsignorID){
                that.ConsignorMsg=e
              }
            })
          }
      })
    },
    //产品信息库默认地址显示到发票产品信息库中
    async getCargoDataAPI(){
      let that=this
      that.api.param={}
      // that.api.url=that.$api02 + '/api/EbayCustomer/BasProduct/Get';
      that.api.url=that.$api04 + "/Basics/api/BasProduct/Get";
      await fetch(that.api.url,that.api.param).then(function (res) {
        if(res.Results.length > 0){
          res.Results.forEach(item =>{
            that.$set(item, 'Id', item.ID);
              if(item.IsSelected==true){
                  //取值到组件
                  that.porductDefultMsg.push(item)
              }
          })
        }
      })
    },
   
    //获取编辑过后的发票详情页面的值，赋值到发票组件中
    async getInvoiceInfo(invoiceId){
        let that=this
        that.api.param={
          //id:invoiceId
        }
        // that.api.url=that.$api02 + '/api/EbayCustomer/MyInvoice/GetDetial/'+invoiceId;
        that.api.url=that.$api04 + '/Basics/api/MyInvoice/GetDetial/'+invoiceId;
        await fetch(that.api.url,that.api.param).then(function (res) {
          if(res.Results){
            that.myInvoiceInfo=res.Results
           // console.log(' that.myInvoiceInfo '  +  JSON.stringify( that.myInvoiceInfo))
          }
        })
      },

       //-------提交表单的确定按钮-调用子组件方法------------//
     clkSubmitFun() {
       this.$refs.clkSubmit.submitFormData(); 
    },

    //子组件点击提交的时候出发方法，并且传值到父组件中
    //发票组件传页面上的值过来
    invoiceByValue(invoiceValue){
      if(this.$route.query.ConsignorID == 0){
        this.saveNewInvoiceApi(invoiceValue)
      }else{
        this.saveEditInvoiceApi(invoiceValue)
      }
    },

    //点击制作新发票保存接口
    saveNewInvoiceApi(invoiceValue){
      let that=this
      that.api.param={
        CommercialINvoice:'COMMERCIAL INVOICE',
        InvoiceNO:invoiceValue.InvoiceNo, //我的发票ID
        DateofExportation:new Date(invoiceValue.DateofExportation).Format('yyyy-MM-dd'), //合同日期
        CountryofOrigin:invoiceValue.originalCountry, //原产地
        WaybillNO:invoiceValue.WaybillNO, //订单号
        TemplateInvoicePath:'/myInfo/CommonInvoice', //发票路径
        //发件人信息
        ShipperID:invoiceValue.InvoiceNo, //发件人ID
        ShipperCompany:invoiceValue.shipperCompany, 
        ShipperContact:invoiceValue.shipperContact,
        ShipperTel:invoiceValue.shipperTEL,
        ShipperAddress:invoiceValue.shipperAddr,
        ShipperProKey:invoiceValue.shipperProvKey,
        ShipperProName:invoiceValue.shipperProv,
        ShipperCityKey:invoiceValue.shipperCity_Key,
        ShipperCityName:invoiceValue.shipperCity,

       //收件人信息      
       ConsigneeID:invoiceValue.InvoiceNo, //收件人ID
       ConsigneeCompany:invoiceValue.consigCompany, 
       ConsigneeContact:invoiceValue.consigContact,
       ConsigneeTel:invoiceValue.consigTEL,
       ConsigneeCountryKey:invoiceValue.Country_Key,
       ConsigneeCountryName:invoiceValue.consigCountry,
       ConsigneeZipCode:invoiceValue.consigZipCode,
       ConsigneeAddress:invoiceValue.consigAddr,
       ConsigneeCityName:invoiceValue.consigCity,

       //产品对象集合
      // ProductInfos:[],
      }
      //产品对象集合
      let porductArrJson=[]
      invoiceValue.goodsInfoList.forEach(e =>{
        let porductArr={
          EnglishName:e.Commodity,
          Material:e.Material,
          CustomsCode:e.HSCode,
          Purpose:e.Use,
          Quanlity:e.Qty,
          Price:e.UnitPrice,
          Unit:e.Unit,
        }
        porductArrJson.push(porductArr)
      })
      that.api.param.ProductInfos=porductArrJson

      // that.api.url=that.$api02 + '/api/EbayCustomer/MyInvoice/SaveInvoiceEn';
      that.api.url=that.$api04 + '/Basics/api/MyInvoice/SaveInvoiceEn';
      post(that.api.url,that.api.param).then(function (res) {
        if(res.IsOK==true){
          that.$confirm( 'Saved successfully','',  {
            customClass:'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
            // showCancelButton:false,//去掉取消按钮
            //showClose:false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {
            window.location.href='/myInfo/myInvoice'
          }).catch(() => {
    
          });
          return false
        }
      })
    },

    //点击编辑的时候里面的保存接口
    saveEditInvoiceApi(invoiceValue){
      let that=this
      that.api.param={
        InvoiceInfoID:this.$route.query.CusInvoiceID,//我的发票ID
        CommercialINvoice:'COMMERCIAL INVOICE',
        InvoiceNO:invoiceValue.InvoiceNo, 
        DateofExportation:new Date(invoiceValue.DateofExportation).Format('yyyy-MM-dd'), //合同日期
        CountryofOrigin:invoiceValue.originalCountry, //原产地
        WaybillNO:invoiceValue.WaybillNO, //订单号
        TemplateInvoicePath:'/myInfo/CommonInvoice', //发票路径
        //发件人信息
       // ShipperID:this.$route.query.ConsignorID, //发件人ID
        ShipperCompany:invoiceValue.shipperCompany, 
        ShipperContact:invoiceValue.shipperContact,
        ShipperTel:invoiceValue.shipperTEL,
        ShipperAddress:invoiceValue.shipperAddr,
        ShipperProKey:invoiceValue.shipperProvKey,
        ShipperProName:invoiceValue.shipperProv,
        ShipperCityKey:invoiceValue.shipperCity_Key,
        ShipperCityName:invoiceValue.shipperCity,

       //收件人信息      
       ConsigneeID:invoiceValue.InvoiceNo, //收件人ID
       ConsigneeCompany:invoiceValue.consigCompany, 
       ConsigneeContact:invoiceValue.consigContact,
       ConsigneeTel:invoiceValue.consigTEL,
       ConsigneeCountryKey:invoiceValue.Country_Key,
       ConsigneeCountryName:invoiceValue.consigCountry,
       ConsigneeZipCode:invoiceValue.consigZipCode,
       ConsigneeAddress:invoiceValue.consigAddr,
       ConsigneeCityName:invoiceValue.consigCity,

       //产品对象集合
      // ProductInfos:[],
      }
      //产品对象集合
      let porductArrJson=[]
      invoiceValue.goodsInfoList.forEach(e =>{
        let porductArr={
          EnglishName:e.Commodity,
          Material:e.Material,
          CustomsCode:e.HSCode,
          Purpose:e.Use,
          Quanlity:e.Qty,
          Price:e.UnitPrice,
          Unit:e.Unit,
        }
        porductArrJson.push(porductArr)
      })
      that.api.param.ProductInfos=porductArrJson

      // that.api.url=that.$api02 + '/api/EbayCustomer/MyInvoice/UpdateInvoiceEn';
      that.api.url=that.$api04 + '/Basics/api/MyInvoice/UpdateInvoiceEn';
      post(that.api.url,that.api.param).then(function (res) {
        if(res.IsOK==true){
          that.$confirm( 'Saved successfully','',  {
            customClass:'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
            // showCancelButton:false,//去掉取消按钮
            //showClose:false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {
            window.location.href='/myInfo/myInvoice'
          }).catch(() => {
    
          });
          return false
        }
      })

    },

  }
};



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/myInfo/CommonInvoice.js